<template>
  <v-app id="comorbidades" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          :custom-filter="filterByName"
        >
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:item.no_cidadao="{ item }">
            {{ item.no_cidadao !== null ? item.no_cidadao : '' }}
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              formatDate(item.dt_nascimento) !== undefined
                ? formatDate(item.dt_nascimento)
                : ''
            }}
          </template>

          <template v-slot:item.no_mae="{ item }">
            {{ item.no_mae !== undefined ? item.no_mae : '' }}
          </template>
          <template v-slot:item.micro_area="{ item }">
            {{ item.micro_area !== undefined ? item.micro_area : '' }}
          </template>

          <template v-slot:item.comorbidades="{ item }">
            <div>
              <span>
                <!-- {{ item.comorbidades.map((c) => c.label).join(', ') }} -->
                {{
                  item.comorbidades
                    ? filtrarComorbidades(item.comorbidades)
                        .map((c) => c.label)
                        .join(', ')
                    : ''
                }}
              </span>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="6">
              <table class="table table-interna table-interna-comorbidades">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Cadastrado por</th>
                    <th>Médico(a)</th>
                    <th>Enfermeiro(a)</th>
                    <th>Odontólogo(a)</th>
                    <th>Visita</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.nu_cpf || '' }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.nu_cns || '' }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.no_profissional || '' }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ult_fai_med) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ult_fai_enf) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ult_fao) }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ formatDate(item.dt_ult_fvdt) }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="#0D98BB"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      comorbidadesFiltradas: [],
      currentPage: 1,
      expanded: [],
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: 'Condições de saúde',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'comorbidades',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    indexedItems: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    filtrarComorbidades(comorbidades) {
      const temComorbidadeHipertensosDiabeticos = comorbidades.some(
        (comorbidade) => {
          return comorbidade.label === 'Hipertensão e diabetes'
        }
      )
      if (temComorbidadeHipertensosDiabeticos) {
        return comorbidades.filter((comorbidade) => {
          return (
            comorbidade.label !== 'Hipertensão' &&
            comorbidade.label !== 'Diabetes'
          )
        })
      }

      return comorbidades
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    filterByName(items, search, filter) {
      if (filter.no_cidadao !== undefined) {
        return (
          filter.no_cidadao
            .toString()
            .toUpperCase()
            .indexOf(search.toUpperCase()) !== -1
        )
      }
    },
  },
}
</script>

<style scoped lang="scss">
.table .table-interna-comorbidades {
  tbody {
    tr {
      td {
        vertical-align: text-top;
      }
    }
  }
}
.table-interna {
  width: 100%;
  margin: 25px auto;
  display: table;
  thead {
    tr {
      background-color: #f7f7f7;
    }
  }
  tbody {
    tr {
      margin-bottom: 10px;
      td {
        span {
          font-size: 13px !important;
          color: #000 !important;
        }
      }
      td {
        ul {
          list-style-type: disc;
        }
      }
    }
  }
}

#comorbidades .td-interna {
  border-bottom: unset;
  padding: 0 16px;
  gap: 5px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /*   margin-bottom: 10px; */
  margin-bottom: 0px;
  gap: 20px;
  span {
    width: 195px;
    display: flex;
  }
  .div-td-interna {
    display: flex;
    /*   min-width: 67px; */
    gap: 5px;
  }

  @media screen and (max-width: 600px) {
    display: flex;
    align-items: center;
  }
  span {
    font-weight: bold;
    color: #00000099;
    font-size: 16px;
  }
}
.cpf-cns {
  margin-bottom: 0px;
}
.endereco {
  margin-top: 0px !important;
  width: 452px;
}
</style>

<style>
#comorbidades
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  height: 116px;
}
</style>
